// extracted by mini-css-extract-plugin
module.exports = {"button":"_3ysMn","small":"_3An0P","medium":"_WzJG","big":"_2BbGT","squared":"_2cHdB","opacity":"_1ze7o"};